import { render, staticRenderFns } from "./PreferFrontCameraSwitch.vue?vue&type=template&id=3695d226&"
import script from "./PreferFrontCameraSwitch.vue?vue&type=script&lang=js&"
export * from "./PreferFrontCameraSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports